import React, { useState, useEffect } from 'react';
import { compose, prop } from 'ramda';
import { Loader } from 'js/components/common/Loader';
import { useGamesConfiguration } from 'js/hooks/games';
import { withComponent } from 'js/components/hocs/withComponent';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';
import { useComponentMethods } from 'js/hooks/component/useComponentMethods';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from './hooks';
import { VIEW } from './constants';
import { Line } from './components/Line';
import { Table } from './components/Table';
import { Carousel } from './components/Carousel';
import { withDynamicReducer, useDynamicReducerSelector } from './store';

import style from './TopWinners.scss';

export const TopWinnersBare = () => {
    let content = null;
    const translate = useComponentTranslations();
    const { view = VIEW.TABLE } = useComponentConfig();
    const { showComponentError } = useComponentMethods();
    const { isGamesConfigLoading } = useGamesConfiguration();
    const isLoading = useDynamicReducerSelector(prop('isLoading'));
    const [error, setError] = useState('');
    const topWinners = hooks.useTopWinners();

    hooks.useFetchComponent({ setError });

    useEffect(() => {
        if (error) {
            showComponentError(error);
        }
    }, [error, showComponentError]);

    if (isLoading || isGamesConfigLoading) {
        return (
            <div className={`${style.wrapper} ${style.loader}`}>
                <Loader />
            </div>
        );
    }

    switch (view) {
        case VIEW.CAROUSEL:
            content = <Carousel />; break;
        case VIEW.TABLE:
            content = <Table />; break;
        case VIEW.LINE:
            content = <Line />; break;
        default: break;
    }

    return (
        <div className={`${style.wrapper} ${style[`${view}View`]} cms-top-winners`}>
            {topWinners.length
                ? content
                : <span>{translate('noWinners')}</span>
            }
        </div>
    );
};

export const TopWinners = compose(
    withComponent({
        tkPrefix: 'playtech.mobile.system.top-winners.'
    }),
    withDynamicReducer()
)(TopWinnersBare);

export default TopWinners;
